<div class="{{ styleBackgroundClass }} modal-header">
    <h5 class="mb-0">
        <i class="bi bi-exclamation-circle pe-2"></i>{{ title | translate }}
    </h5>
</div>
<div class="modal-body">
    <p class="fw-bold">
        {{ message }}
    </p>
</div>
<div class="modal-footer">
    <button class="btn btn-econdary" (click)="onClose($event)">Cancel</button>
</div>
